import styled from 'styled-components';
import { palette } from 'styled-theme';
import { WithDirection } from '@jjj/components';

const CreateLegalEntityWrapper = styled.div`
  width: 100%;

  .section-title {
    margin: 0 0 16px 0;
    font-size: 16px;
    font-weight: 600;
    color: ${palette('grayscale', 0)};
  }

  .has-error {
    .ant-input,
    .ant-input-affix-wrapper,
    .ant-select-selector {
      background-color: ${palette('error', 2)} !important;
      border-color: ${palette('error', 0)} !important;
    }

    .ant-input:-webkit-autofill,
    .ant-input:-webkit-autofill:hover,
    .ant-input:-webkit-autofill:focus {
      -webkit-box-shadow: 0 0 0 1000px ${palette('error', 2)} inset !important;
      box-shadow: 0 0 0 1000px ${palette('error', 2)} inset !important;
    }
  }

  .form-footer {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    margin-top: 16px;
    padding: 0 4px;
  }
`;

export default WithDirection(CreateLegalEntityWrapper);
